<template>
  <div class="app-agreement">
    <div class="content">
      <p class="MsoBodyText">
        <b>
          <p class="MsoNormal" style="vertical-align: baseline">
            供给云第三方配送服务协议
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>一、导语</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            欢迎你使用供给云第三方配送服务！
          </p>
          <p class="p" style="vertical-align: baseline">
            <span>你在使用供给云第三方配送服务（以下简称</span
            ><span
              >“本服务”）前，你应当阅读并遵守《供给云第三方配送服务协议》。</span
            ><b
              ><u
                ><span
                  >请你谨慎阅读、充分理解本协议各条款内容，特别是免除或限制责任的条款，并选择接受或不接受。限制、免责条款可能以加粗下划线形式提示你注意。</span
                ></u
              ></b
            ><u></u>
          </p>
          <p class="p" style="vertical-align: baseline">
            <b
              ><u
                ><span
                  >如你选择不接受本协议，你可能将无法使用供给云第三方配送服务。一旦你开通本服务或以其他形式实际使用本服务，即视为你已阅读、充分理解并接受本协议。</span
                ></u
              ></b
            ><u></u>
          </p>
          <p class="p" style="vertical-align: baseline">
            <span>你是使用</span> <span>全升时代科技（北京）有限公司</span>
            <span>提供的软件服务（以下简称</span
            ><span
              >“供给云”）的供给云商户。本协议是你与供给云因使用供给云接入的第三方配送服务，而与供给云订立的正式协议，本协议是电子合同，在你与供给云间具有《中华人民共和国合同法》上的效力。</span
            >
          </p>
          <p class="p" style="vertical-align: baseline">
            本协议同时包括供给云可能不时发布或更新的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分。你与供给云签订的书面合同与本协议不一致的，以书面合同为准。
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>二、定义</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)供给云，是为你提供账户信息管理，配送信息发布与查询、配送交易撮合与处理、订单查询与管理、定价建议与咨询、代理配送费磋商与谈判、配送费用代收代垫与代付、交易合同与凭证保管、信用等级评定与披露、交易数据处理、争议调解等互联网信息服务和在线交易处理服务的服务商。供给云并不直接参与你与用户之间的配送交易，双方因配送合同履行发生争议的，应当根据合同相对性原则自行协商处理或寻求供给云介入调解争议。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)用户，是指第三方配送平台上提供配送服务的实际承运人。本协议项下，特指已经注册或使用第三方配送平台，且具有完成配送服务之条件和资质的用户。用户依约完成配送订单的，有权根据第三方配送平台自你处获取相应的报酬。任何时候，用户与第三方配送平台之间并非劳动、劳务、雇佣关系。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)你，是指购买供给云软件服务的供给云商家，也是在第三方配送平台发布配送服务需求的，在第三方配送平台显示为配送订单需求方的，具有向货物接受人销售或配送货物资质的个人、企业、组织或机构。本协议项下，特指已经登录供给云，并自愿申请注册，且具有销售或配送货物的条件和资质的供给云商户。你应当根据供给云的业务规则及订单信息，向依约完成配送订单的用户支付报酬。
          </p>
          <p class="p" style="vertical-align: baseline">
            (四)配送订单，是指供给云商户通过第三方配送平台发布的，在第三方配送平台显示的配送服务要约信息（包括但不限于供给云商户信息、配送货物、配送地址、收货人信息及配送费用等），用户一旦通过点击或确认的方式承诺配送订单的，配送合同即为生效。订单作为用户与供给云商家间的配送合同，是双方权利义务的证明文件；双方线下达成交易条件（例如代收货款、附条件配送等）的，各自自行保留相应的证据。
          </p>
          <p class="p" style="vertical-align: baseline">
            (五)第三方配送平台，是指供给云合作的提供配送业务的第三方平台，包括但不限于：达达、饿了么、蜂鸟、美团等配送平台。
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>三、协议签署与修订</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)供给云只接受依法存续的、具有相应资质的企业或组织成为供给云商户。如你不符合前述要求，请勿注册供给云账户或实际使用供给云提供的服务。<b
              ><u
                ><span
                  >供给云有权中止或终止不符合前述条件的供给云商户的资格并停止向其提供服务</span
                ></u
              ></b
            ><u><span>，</span></u
            >因此给供给云造成损失的，供给云有权向你索赔。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)你承诺你应当符合相应条件及资质向收货人销售或配送订单约定的配送货物，配送货物涉及国家专营或依审批从事的业务时，你应当取得相应的全部审批文件及资质。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)你应当保证注册时提供的信息和资质的完整性、真实性、合法性、时效性。供给云有权根据业务需要，不时审核你的注册信息及提供的资质是否完整、真实有效，<u
              ><span>一</span></u
            ><b
              ><u
                ><span
                  >旦发现你的信息和资质不符合供给云业务规则的，供给云有权中止或注销该你。因供给云数据庞大、商户众多，如供给云暂未审核你的资质，或者暂未中止或注销你的账号，并不代表供给云认可你的注册信息的有效性，亦不代表放弃采取行动或追究相关法律责任的权利。</span
                ></u
              ></b
            ><u></u>
          </p>
          <p class="p" style="vertical-align: baseline">
            (四)你通过自行或授权第三方根据本协议及业务规则、说明文件操作确认本协议后，本协议即在你与供给云之间产生法律效力。本协议不涉及你与用户之间因配送合同产生的法律关系或法律纠纷，但<b
              ><u
                ><span
                  >你在此同意将全面接受和履行与用户在供给云签订的任何电子法律文本，并承诺按该等法律文本享有和</span
                ><span>/或放弃相应的权利、承担和/或豁免相应的义务</span></u
              ></b
            >。配送订单一经用户抢单确认，你将无法撤销订单；用户如约完成订单的，你应当支付相应的配送费。<b
              ><u
                ><span
                  >供给云有权根据业务规则采取扣款、收取违约金、中止订单发布资格、注销账户等方式处理你的履约瑕疵行为。</span
                ></u
              ></b
            ><u></u>
          </p>
          <p class="p" style="vertical-align: baseline">
            (五)为了保证本服务的安全性和功能的一致性，<b
              ><u
                ><span
                  >供给云有权不特别通知你而对本服务的部分功能进行更新，或者对供给云的部分功能效果进行改变或限制。</span
                ></u
              ></b
            ><u></u>
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>四、关于本服务</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)供给云提供的本服务内容为：提供配送信息发布与查询、配送交易撮合与处理、订单查询与管理、交易数据处理等互联网信息服务。具体以供给云届时提供的有效服务内容为准。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)尽管供给云尽力保证服务的有效性和可用性，但因电信故障、黑客攻击或政策变动等因素，可能导致前述服务部分或全部无效或调整，你理解并接受该等情形的出现，并同意在该等情形下供给云免责。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)你应当自行准备如下服务设备，并承担相应开支：
          </p>
          <p class="p" style="vertical-align: baseline">
            1.&nbsp;&nbsp;&nbsp;服务设备，包括并不限于手机、电脑或者其他移动终端、调制解调器及其他必备的上网装置。
          </p>
          <p class="p" style="vertical-align: baseline">
            2.&nbsp;&nbsp;&nbsp;服务开支，包括并不限于网络接入费、上网设备租用费、网络宽带或流量费、配送费用、结算手续费，以及履行配送服务过程可能发生的其他费用等。&nbsp;
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>五、账户管理</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)
            你在使用本服务前需要注册一个供给云账号。供给云账号可通过手机号码进行注册，供给云有权根据用户需求或产品需要对账号注册方法进行变更。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二) 你有责任妥善保管注册账户信息及账户密码的安全。<b
              ><u
                ><span>用户需要对注册帐户以及密码下的行为承担法律责任</span></u
              ></b
            ><u><span>。</span></u
            >用户同意在任何情况下不向他人透露帐户及密码信息。当在你怀疑他人在使用你的帐号时，你应立即通知供给云。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三) 你理解并同意，<b
              ><u
                ><span
                  >供给云通过向你注册供给云店铺时预留的地址、电话、邮箱等任一方式发送信息，或者向你发送站内信息，即视为供给云向你履行了送达、通知义务。</span
                ></u
              ></b
            ><u></u>
          </p>
        </b>
      </p>
      <p class="MsoBodyText">
        <b> </b>
      </p>
      <p class="MsoNormal" style="vertical-align: baseline">
        <b>
          <p class="p" style="vertical-align: baseline">
            <b>六、交易管理</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)你可根据自身条件或业务发展需要，通过供给云发布合法的、完整的配送服务需求。供给云有权根据相关规则审核你的资质及配送服务需求信息，并有权决定相关配送服务需求信息的发布方式及发布时间，以及有权决定相关信息被特定或不特定的用户获取。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)你通过供给云预付或后付配送费的，相关合同、充值、扣款、发票及凭证索取等规则，参照供给云届时有效的规则执行。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)你确认，你在供给云上按业务规则所确认的交易状态，将成为供给云为你进行相关交易或操作（包括但不限于支付或收取款项、冻结资金、订立合同等）的不可撤销的指令。你同意相关指令的执行时间以供给云在系统中进行实际操作的时间为准。你同意供给云有权依据本协议及/或供给云相关纠纷处理规则等约定对相关事项进行处理。
          </p>
          <p class="p" style="vertical-align: baseline">
            (四)因你未能及时对交易状态进行修改、确认或未能提交相关申请所引起的任何纠纷或损失，由你自行负责，供给云不承担任何连带、担保等责任。<sub
            ></sub>
          </p>
          <p class="p" style="vertical-align: baseline">
            (五)供给云有权基于交易安全等方面的考虑不时设定涉及交易的相关事项的限制，包括但不限于交易限额、交易次数限制等。你了解，供给云的前述设定可能会对你的交易造成一定不便，你对此没有异议。
          </p>
          <p class="p" style="vertical-align: baseline">
            (六)如果供给云发现了因系统故障或其他原因导致的处理错误，无论有利于供给云、用户还是有利于你，供给云将按照本协议规定通知你，并纠正该错误、回转/回档相关交易或数据。<b
              ><u
                ><span
                  >你理解并同意，你因前述处理错误而多付或少付的款项均不计利息，供给云不承担因前述处理错误而导致的任何损失或责任（包括你可能因前述错误导致的利息、汇率等损失）</span
                ></u
              ></b
            ><b>，</b>但因供给云恶意而导致的处理错误除外。
          </p>
          <p class="p" style="vertical-align: baseline">
            (七)你与用户达成配送订单信息以外的线下交易或条件（例如代收货款、附条件配送等）的，你应当自行保留相应的证据，并在各自责任范围内承担相应的法律责任。
          </p>
          <p class="p" style="vertical-align: baseline">
            (八)你决定不再使用本服务时，应首先清偿所有应付款项（包括但不限于到期或未到期的贷款本金、利息、罚息、违约金、服务费、管理费等），再将你账户中的可用款项（如有）全部取现或者向供给云发出其它合法的支付指令，并向供给云申请注销该你账户，经供给云审核同意后可正式停止使用。如你不幸去世而停止使用的，你在本协议项下的各项权利义务由你的继承人或合法承继主体承担。若你丧失全部或部分民事权利能力或民事行为能力，供给云或你授权的主体有权根据有效法律文书（包括但不限于生效的法院判决等）或你的监护人的指示处置与你账户相关的款项。
          </p>
          <p class="p" style="vertical-align: baseline">
            (九)你在交付配送货物之前，应当自行审核用户的真实性及履约能力，有义务验明用户的真实身份信息，要求用户提供履约担保。特别地，供给云作为交易信息平台，无法控制每一用户配送质量、效率或合法性。
          </p>
          <p class="p" style="vertical-align: baseline">
            (十)你应当向用户明示配送货物的性质和品类，配送注意事项，以及货物接收人的信息；因你故意隐瞒或遗漏相关信息而使用户或第三方遭受人身损害、财产损害的，你应当依法承担相应的法律责任，供给云因此遭受损失的，有权向你追偿。
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>七、电子合同与订单</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)在供给云交易需订立的协议、订单采用电子合同方式，可以有一份或者多份（每一份具有同等法律效力）。你或你的代理人根据有关协议及供给云的业务规则，在供给云通过点击确认或类似方式签署的电子合同、订单，即视为你本人真实意愿并以你本人名义签署的合同，具有法律效力。你应妥善保管自己的供给云账户密码等账户信息，你通过前述方式订立的电子合同、订单对合同各方具有法律约束力，你不得以账户密码等账户信息被盗用或其他理由否认已订立的合同的效力或不按照该等合同履行相关义务。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)你根据本协议以及供给云的相关规则签署电子合同、订单后，不得擅自修改该合同、订单。供给云向你提供电子合同、订单的保管、备案、查询、核对等服务，如对电子合同、订单真伪或电子合同、订单的内容有任何疑问，你可通过供给云的相关系统板块查阅有关合同、订单并进行核对。如对此有任何争议，应以供给云保存的合同、订单为准。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)你不得私自仿制、伪造在供给云上签订的电子合同或印章，不得用伪造的合同、订单进行招摇撞骗或进行其他非法使用，否则由你自行承担责任；供给云有权向相关司法机关投诉、举报或报案等。
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>八、你的信息及隐私权保护</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)
            保护用户信息是供给云的一项基本原则，供给云将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可供给云不会向第三方公开、透露用户个人信息。供给云对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)
            你在注册账号或使用本服务过程中，需要提供一些必要信息，譬如：为你提供帐号注册服务或进行用户身份识别，需要你填写手机号码。若国家法律法规或政策有特殊规定的，你需要提供真实的身份信息。若你提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)
            一般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，你可能无法修改注册时提供的初始注册信息及其他验证信息。
          </p>
          <p class="p" style="vertical-align: baseline">
            (四)
            供给云将运用各种安全技术和程序建立完善的管理制度来保护你的个人信息，以免遭受未经授权的访问、使用或披露。
          </p>
          <p class="p" style="vertical-align: baseline">
            (五)
            未经你的同意，供给云不会向供给云以外的第三方披露你的个人信息，但法律法规另有规定的除外。
          </p>
          <p class="p" style="vertical-align: baseline">
            <span
              >(六)
              关于供给云会如何收集、使用、存储和保护你的个人信息及你享有何种权利，你还可以阅读</span
            ><span>《隐私政策》。</span>&nbsp;
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>九、你对其他用户信息的使用</b>
          </p>
          <p class="p" style="vertical-align: baseline">
            (一)在供给云提供的交易活动中，你无权要求供给云提供其他你或用户的资料，除非符合以下条件：
          </p>
          <p class="p" style="vertical-align: baseline">
            1.&nbsp;&nbsp;&nbsp;你已向法院起诉其他你或用户的在供给云活动中的违约行为；
          </p>
          <p class="p" style="vertical-align: baseline">
            2.&nbsp;&nbsp;&nbsp;与用户存在配送服务纠纷；
          </p>
          <p class="p" style="vertical-align: baseline">
            3.&nbsp;&nbsp;&nbsp;供给云被吊销营业执照、解散、清算、宣告破产或者其他有碍于你实现配送服务的情形。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)如你通过签署有关协议等方式获得用户的信息，你同意不将该等信息用于除配送服务以外的其他任何用途，除非该等信息根据适用的法律规定、被有管辖权的法院或政府部门要求披露。
          </p>
          <p class="p" style="vertical-align: baseline">
            <b>十、知识产权声明</b>
          </p>
          <p class="MsoNormal">
            (一)
            供给云是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、
          </p>
          <p class="p" style="vertical-align: baseline">
            有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，供给云享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
          </p>
          <p class="p" style="vertical-align: baseline">
            (二)
            未经供给云或相关权利人书面同意，你不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。
          </p>
          <p class="p" style="vertical-align: baseline">
            (三)
            你使用本软件及服务过程中上传、发布的全部内容，均不会因为上传、发布行为发生知识产权、肖像权等权利的转移。与此同时，你理解并同意供给云为实现产品目的，对你发布的特定公开非保密内容在法律允许的范围内进行使用，包括但不限于予以存储、向有关用户播放、供有关用户获取及再次使用等。&nbsp;
          </p>
        </b>
      </p>

      <p>
        <br />
      </p>
      <p class="MsoBodyText">
        <b> </b>
      </p>
      <p class="MsoNormal" style="vertical-align: baseline">
        <b> </b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b> </b></b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b
          ><b>
            <p class="p" style="vertical-align: baseline">
              <b>十一、风险提示与责任限制（重要）</b>
            </p>
            <p class="p" style="vertical-align: baseline">
              (一)你理解并同意，你委托的配送服务的合同相对方是用户，合同履行的瑕疵担保及付款责任应当由用户根据约定内容承担，作为交易服务的供给云，与用户无劳动、雇佣或合作关系，不向用户承担任何担保或连带责任。
            </p>
            <p class="p" style="vertical-align: baseline">
              (二)有且仅当法律法规明确要求，或出现以下情况，供给云才对你及用注册信息、配送订单信息进行事先或事后的审查：
            </p>
            <p class="p" style="vertical-align: baseline">
              1.&nbsp;&nbsp;&nbsp;应你或用户要求的，且有合理的理由认为特定你、用户或交易可能存在重大违法或违约情形。
            </p>
            <p class="p" style="vertical-align: baseline">
              2.
              &nbsp;&nbsp;&nbsp;&nbsp;应你或用户要求的，且有合理的理由认为你、用户在供给云的行为涉嫌违法或不当。
            </p>
            <p class="p" style="vertical-align: baseline">
              3.&nbsp;&nbsp;&nbsp;你理解并同意，受限于数据及技术条件，供给云的前述审查行为无法做到完全审查。
            </p>
            <p class="p" style="vertical-align: baseline">
              (三)鉴于你委托的配送服务的合同相对方是用户，就配送过程中发生的损失，应由你与用户直接解决。供给云平台可提供协助，但非责任主体。配送过程中发生遗失、破损的情况时，如你已采取保价措施的，按照第三方物流平台的保价规则获得赔偿；若未进行保价，你理解并同意，依据法律或本协议有明确的赔偿义务的前提下，第三方物流的赔偿限额为单笔配送订单的货物价格（价格高于人民币200元的，你应当与第三方物流公司另行签订书面合同），且不对因下述情况而导致的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿：
            </p>
            <p class="p" style="vertical-align: baseline">
              1.&nbsp;使用或未能使用供给云的服务；
            </p>
            <p class="p" style="vertical-align: baseline">
              2.&nbsp;第三方未经批准地使用或更改你的数据；
            </p>
            <p class="p" style="vertical-align: baseline">
              3.&nbsp;通过供给云的服务购买或获取任何商品、样品、数据、信息等行为或替代行为产生的费用及损失；
            </p>
            <p class="p" style="vertical-align: baseline">
              4. &nbsp;你对供给云的服务的误解；
            </p>
            <p class="p" style="vertical-align: baseline">
              5.&nbsp;任何非因供给云的过错原因而引起的与供给云的服务有关的其它损失。
            </p>
            <p class="p" style="vertical-align: baseline">
              (四)如因不可抗力或供给云无法控制的其他原因使供给云系统崩溃或无法正常使用，从而导致配送交易无法完成或丢失有关的信息、记录等，供给云不承担责任。供给云会尽可能合理地协助处理善后事宜，并努力使你免受或减少经济损失。
            </p>
            <p class="p" style="vertical-align: baseline">
              (五)在任何情况下，供给云及其股东、创建人、高级职员、董事、代理人、关联公司、母公司、子公司和雇员（以下称“供给云”）均不以任何明示或默示的方式对你使用本服务而产生的任何形式的直接或间接损失承担法律责任，包括但不限于资金损失、利润损失、营业中断损失等，供给云不保证网站内容的真实性、充分性、及时性、可靠性、完整性和有效性，并且免除任何由此引起的法律责任。
            </p>
            <p class="p" style="vertical-align: baseline">
              (六)供给云不对你所发布信息的删除或储存失败、遗失负责，你应当自行备份你信息及使用数据。
            </p>
            <p class="p" style="vertical-align: baseline">
              (七)你理解并同意，供给云可能会与第三方合作向你提供相关的服务（包括但不限于广告服务、支付服务、数据服务、导航定位服务等），在此情况下，供给云不保证该第三方提供的服务的可用性、有效性和合法性。
            </p>
            <p class="p" style="vertical-align: baseline">
              (八)你应当对待配送物品进行仔细检查，确保物品完好无损，并对其进行妥善的包装以保证在配送途中不会因包装不妥而出现毁损、灭失或变质。
            </p>
            <p class="p" style="vertical-align: baseline">
              (九)待配送物品有温度要求的，你应当提供保温设备并向配送人员提示注意事项，同时也应当查验配送人员是否具备配送该类物品的条件。
            </p>
            <p class="p" style="vertical-align: baseline">
              (十)待配送物品为食品的，你将物品交付用户前应当确保其拥有有效的健康证明，盛放食品的容器干净整洁能够防尘、防雨。
            </p>
            <p class="p" style="vertical-align: baseline">
              <span>（十一）你应在实际承运人接单后</span
              ><span
                >10分钟内备货完毕，因你备货超时造成用户配送超时的，不视为用户违约，用户不承担任何赔付责任。用户在接单后1</span
              >5<span>分钟内（含</span><span>1</span>5<span
                >分钟）尚未取货的，你如取消订单须向供给云支付</span
              ><span>2元/单的服务费作为补偿；用户在接单后超过1</span>5<span
                >分钟（不含</span
              ><span>1</span
              >5分钟）尚未取货的，你有权无责取消订单；若订单处于已配送状态，你取消订单须向供给云支付该笔订单的全额服务费。
            </p>
            <p class="p" style="vertical-align: baseline">
              （十二）你应在用户取货时核对其信息，避免货物交付给错误用户等情况发生，因你未履行前述义务导致收件人未收到货物或错收货物由你承担责任。
            </p>
            <p class="p" style="vertical-align: baseline">
              （十三）你应保证用户取货环境安全，定期进行环境隐患排查，及时消除安全隐患，开展包括但不限于确保进出口通畅、消防设施齐全、电路安装有序、不存放易燃易爆等危险物品、障碍物提示、安全隐患提醒等安全工作。如因你未能履职导致用户取货过程中发生伤亡等安全事件，责任由你承担。
            </p>
            <p class="p" style="vertical-align: baseline">
              （十四）你不可指挥或强烈要求用户从事本协议约定配送之外的包含但不限于拣货、打包货物等非配送任务，如因此产生的安全事件由你承担责任。
            </p>
            <p class="p" style="vertical-align: baseline">
              （十五）你对配送货物有特殊安全配送要求应进行安全配送注意事项提示，如未能事先安全提示导致货物受损、用户受伤等情况，责任由你承担。
            </p>
            <p class="p" style="vertical-align: baseline">
              （十六）如你知悉任何用户发生任何安全事件或事故时，应第一时间告知供给云，确保信息互通。
            </p>
            <h4>
              <p class="p" style="vertical-align: baseline">
                <b>十二、行为规范</b>
              </p>
            </h4>
          </b></b
        >
      </p>
      <p>
        <br />
      </p>
      <p class="MsoBodyText">
        <b> </b>
      </p>
      <p class="MsoNormal" style="vertical-align: baseline">
        <b> </b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b> </b></b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b><b> </b></b>
      </p>
      <p class="p" style="vertical-align: baseline">
        <b
          ><b
            ><b>
              <p class="p" style="vertical-align: baseline">
                (一)在使用本服务过程中，你承诺遵守以下约定：
              </p>
              <p class="p" style="vertical-align: baseline">
                1.&nbsp;&nbsp;&nbsp;在使用供给云的服务过程中实施的所有行为均遵守国家法律、法规等规范文件及供给云的各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。如果违反前述承诺，产生任何法律后果的，你应以自己的名义独立承担所有的法律责任，并确保供给云免于因此产生任何损失。
              </p>
              <p class="p" style="vertical-align: baseline">
                2.&nbsp;&nbsp;&nbsp;不发布法律和法规禁止发布的信息，不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法、违反交易规则或违反本协议及各类规则的信息。
              </p>
              <p class="p" style="vertical-align: baseline">
                3.&nbsp;&nbsp;&nbsp;不对供给云上的任何数据或信息作商业性利用，包括但不限于在未经供给云事先书面同意的情况下，以复制、传播等任何方式使用，或许可、泄露给任何第三方使用，或者为任何第三方使用提供便利，该等责任及于你与本服务关系终止后三年。
              </p>
              <p class="p" style="vertical-align: baseline">
                4.&nbsp;&nbsp;&nbsp;不使用任何装置、软件或例行程序干预或试图干预供给云的正常运作或正在供给云上进行的任何活动。你不得采取任何将导致不合理的庞大数据负载加诸供给云网络设备的行动。
              </p>
              <p class="p" style="vertical-align: baseline">
                5.&nbsp;&nbsp;&nbsp;不得进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器帐号；不得未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；不得未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；不得企图干涉、破坏系统或手机APP的正常运行。
              </p>
              <p class="p" style="vertical-align: baseline">
                6.&nbsp;&nbsp;&nbsp;不得发布任何有损供给云商誉的言论。
              </p>
              <p class="p" style="vertical-align: baseline">
                (二)你理解并同意：
              </p>
              <p class="p" style="vertical-align: baseline">
                1.&nbsp;&nbsp;&nbsp;违反上述承诺时，供给云有权依据本协议的约定，做出相应处理或终止提供服务，且无须征得你的同意或提前通知你。
              </p>
              <p class="p" style="vertical-align: baseline">
                2.&nbsp;&nbsp;&nbsp;根据相关法令的指定或者供给云业务规则的判断，你的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，供给云有权采取相应措施，包括但不限于罚款、暂扣款项、直接屏蔽、删除侵权信息、降低信用值或直接停止提供服务，直至注销账户。
              </p>
              <p class="p" style="vertical-align: baseline">
                3.&nbsp;&nbsp;&nbsp;对于你在供给云上实施的行为，包括未在供给云上实施但已经对供给云及其你产生影响的行为，供给云有权单方认定该行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的必要的处理措施。
              </p>
              <p class="p" style="vertical-align: baseline">
                4.&nbsp;&nbsp;&nbsp;对于你涉嫌违反承诺的行为对任意第三方造成损害的，你均应当以自己的名义独立承担所有的法律责任，并应确保供给云免于承担因此产生的损失或增加的费用。
              </p>
              <p class="p" style="vertical-align: baseline">
                5.&nbsp;&nbsp;&nbsp;如你涉嫌违反有关法律或者本协议之规定，使供给云遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，你应当赔偿供给云因此造成的损失及发生的费用，包括合理的律师费用。
              </p>
              <p class="p" style="vertical-align: baseline">
                (三)你同意在发现供给云任何内容不符合法律规定，或不符合本协议规定的，或用户信息虚假的，有义务及时通知供给云。如果你发现合法权利受到侵害，请将此情况告知供给云并同时提供如下信息和材料：
              </p>
              <p class="p" style="vertical-align: baseline">
                1.&nbsp;&nbsp;&nbsp;侵犯你权利的信息的网址，编号或其他可以找到该信息的细节；
              </p>
              <p class="p" style="vertical-align: baseline">
                2.&nbsp;&nbsp;&nbsp;你的联系方式，包括联系人姓名，地址，电话号码和电子邮件；
              </p>
              <p class="p" style="vertical-align: baseline">
                3.&nbsp;&nbsp;&nbsp;你的身份证复印件、营业执照等其他相关资料。
              </p>
              <p class="p" style="vertical-align: baseline">
                经审查得到证实的，供给云将及时删除相关信息。供给云仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，你可以通过客服电话先行告知，供给云会视情况采取相应措施。
              </p>
              <p class="p" style="vertical-align: baseline">
                (四)你应当严格遵守本协议及供给云发布的其他协议、活动规则，因你违反协议或规则的行为给第三方或供给云造成损失的，你应当承担全部责任，供给云因此承担责任的，有权向你追偿。
              </p>
              <p class="p" style="vertical-align: baseline">
                (五)你应当保证交易的真实性，不得通过伪造交易、伪造收货人等方式刷单或骗取补贴、佣金等。一经发现，供给云有权采取包括冻结款项，扣除获利5至10倍金额的违约金，中止或终止账户，民事索赔（含供给云的全部损失、调查费、律师费等）或刑事报案等措施。
              </p>
              <p class="17" style="text-indent: 0pt">
                （六）你承诺在使用供给云第三方配送服务时，配送的物品中不含以下物品：
              </p>
              <p class="17" style="margin-left: 22pt; text-indent: 0pt">
                1.各类武器、弹药，如枪支、子弹、炮弹、手榴弹、地雷、炸弹、管制刀具等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                2.各类易爆炸性物品，如雷管、炸药、火药等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                3.各类易燃烧性物品，包括液体、气体和固体，如煤油、桐油、柴油等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                4.各类易腐蚀性物品，如火硫酸、危险化学品等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                5.<span>各类放射性元素及容器，如铀、钴、镭、钚等。</span>
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                6.各类烈性毒药，如铊、氰化物、砒霜等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                7.<span
                  >各类麻醉药物，如鸦片（包括婴粟壳、花、苞、叶）、吗啡、可卡因、</span
                >
                <span>海洛因、大麻、冰毒、麻黄素及其它制品等。</span>
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                8.各类生化制品和传染性物品，如炭症、危险性病菌、医药用废弃物等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                9.各种危害国家安全和社会政治稳定以及淫秽的出版物、宣传品、印刷品等，如各种煽动民族仇恨、歧视，破坏民族团结的，宣扬邪教或者迷信的，散布谣言扰乱社会秩序的等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                10.各种妨害公共卫生的物品，如尸骨、动物器官、肢体、未经硝制的兽皮、未经药制的兽骨等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                11.<span
                  >国家法律、法规、行政规章明令禁止流通、寄递或进出境的物品，</span
                >
                <span
                  >如国家秘密文件和资料、珍贵文物、濒危野生动物及其制品等。</span
                >
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                12.包装不当可能危害人身安全、污染或者损毁其他物品、设备等。
              </p>
              <p class="17" style="margin-left: 21pt; text-indent: 0pt">
                13.其他禁止寄递的物品。
              </p>
              <p class="17">
                （七）你承诺，你将如实提供订单详情，包括姓名、地址和配送物品的名称、类别、数量、重量等。
              </p>
              <p class="17" style="margin-left: -18pt; text-indent: 18pt">
                （七）（八）你确保已经了解，你违反国家规定的禁配物品，违反国家禁止出境或者限制出境的物品，被国家有关部门查处的，由你承担相应的法律责任。由此给供给云、用户或者公民、法人及其他组织造成损害的，由你依法承担赔偿责任。
              </p>
              <p class="17" style="text-indent: 0pt">
                <b>十四、法律适用与管辖</b>
              </p>
              <p class="p" style="vertical-align: baseline">
                (一)如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，则应认为该条款可与本协议相分割，并可被尽可能接近各方意图的、能够保留本协议要求的经济目的的、有效的新条款所取代，而且，在此情况下，本协议的其他条款仍然完全有效并具有约束力。
              </p>
              <p class="p" style="vertical-align: baseline">
                (二)供给云在法律允许的范围内对本协议拥有最终的解释权。本协议及供给云有关页面的相关名词可互相引用参照，如有不同理解，则以本协议条款为准。
              </p>
              <p class="p" style="vertical-align: baseline">
                (三)本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
              </p>
              <p class="p" style="vertical-align: baseline">
                (四)本协议及其修订的有效性、履行与本协议及其修订效力有关的所有事宜，将受中国法律管辖，任何争议仅适用中华人民共和国法律。
              </p>
              <p class="p" style="vertical-align: baseline">
                (五)本协议签订地与履行地均为供给云住所地。因本协议所引起的你与供给云的任何纠纷或争议，首先应友好协商解决。协商不成的，争议任一方有权将纠纷或争议提交供给云住所地人民法院诉讼解决。
              </p>
              <p class="p" style="vertical-align: baseline">
                <br />
                收费规则：<br />
                收费规则已经你选择的第三方配送平台下单时显示的实时价格为准，每笔订单业务配送服务、第三方配送方不同、时间不同、地理位置不同等均显示实时价格，你下单时已实时价格为结算价格，下单后价格不再更改，由供给云代收，供给云与你根据下单时系统显示价格作为结算依据，供给云直接从你的供给云店铺余额扣除，为不影响你正常业务的开展，你需要确保账户有余额。配送地区：配送地区以网页显示的可配送区域为准。具体价格会根据距离、重量、时段单独计算，以平台显示为准。
              </p>
              <p class="p" style="vertical-align: baseline">&nbsp;</p>
              <p class="p" style="vertical-align: baseline">
                你确认已知悉并理解上述协议内容，同意与供给云订立上述协议。
              </p>
              <p class="p" style="vertical-align: baseline">&nbsp;</p>
            </b></b
          ></b
        >
      </p>
    </div>
  </div>
</template>

<style lang="less">
.app-agreement {
  min-height: 100vh;
  font-size: 1.4rem;
  white-space: normal;

  .content {
    width: 98%;
    margin: 0 auto;
  }
}
</style>
